<template>
  <v-autocomplete :items="items" :label="prop.text" v-model="model[`${prop.value}`]" browser-autocomplete return-object
    :readonly="readonly" :clearable="!readonly" :item-text="prop.sourceItemText" :item-value="prop.sourceItemValue"
    counter :loading="loading" :multiple="prop.multiple" @change="update">
    <template v-slot:append-outer>
      <v-btn color="secondary" flat icon small @click="refresh">
        <v-icon small>cached</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<style scoped>

</style>

<script>
  import Selection from "./selection.ts";
  export default Selection;
</script>